/*
 * @author: Kody
 * @date: 2018-08-23 12:14:48
 * @description: 退出班级
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    class_id: string;
}

interface IRemoveInput {
    member_id: string;
}

interface IOutput {
    status: number;
}

export const classMemberExit = (param: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.CLASS_MEMBER_EXIT, param).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const classMemberBeenRemove = (param: IRemoveInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.CLASS_MEMBER_BEEN_REMOVE, param).then((res: IResponse<IOutput>) => {
        return res;
    });
};
